// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Shared filter controls for bills browsers: search input + optional extra controls.
 */
import type { FC, ReactNode } from 'react'
import { Input } from '@/components/ui/input'

export interface BillsBrowserFiltersProps {
  search: string
  onSearchChange: (value: string) => void
  testIdPrefix?: string
  /** Extra filter controls to render after the search input */
  children?: ReactNode
}

export const BillsBrowserFilters: FC<BillsBrowserFiltersProps> = ({
  search,
  onSearchChange,
  testIdPrefix,
  children,
}) => (
  <div
    className="flex items-center gap-4 flex-wrap"
    data-testid={testIdPrefix ? `${testIdPrefix}-filters` : undefined}
  >
    <Input
      placeholder="Search bills..."
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      className="w-64"
      data-testid={testIdPrefix ? `${testIdPrefix}-search` : undefined}
    />
    {children}
  </div>
)
